import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import Logo from "../../assets/icons/dp_logo.png";
import "./NavBar.css";

const NavBar = () => {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    const offset = 95; // Adjust this value based on your navbar height
    const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  };

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="md"
        fixed="top"
        className="animate-navbar nav-theme justify-content-between"
        variant="light"
      >
        <Navbar.Brand href="#home">
          <img className="logo" src={Logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <div className="ml-auto d-flex align-items-center">
            <Nav className="mr-3">
              <Nav.Link href="#home" onClick={(e) => handleNavClick(e, "home")}>Inicio</Nav.Link>
              <Nav.Link href="#about" onClick={(e) => handleNavClick(e, "about")}>Nosotros</Nav.Link>
              <Nav.Link href="#projects" onClick={(e) => handleNavClick(e, "projects")}>Colaboradores</Nav.Link>
              <Nav.Link href="#patient-info" onClick={(e) => handleNavClick(e, "patient-info")}>Información para Pacientes</Nav.Link>
              <Nav.Link href="#faq" onClick={(e) => handleNavClick(e, "faq")}>Drepanociwiki</Nav.Link>
              <Nav.Link href="#contact" onClick={(e) => handleNavClick(e, "contact")}>Contacto</Nav.Link>
            </Nav>
            <Button
              as="a"
              href="https://app.drepanocitico.com/"
              className="btn-burgundy mr-2"
            >
              Ingresar
            </Button>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default NavBar;
